import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SharedModule } from '@app/shared/shared.module';
import { ChangePasswordComponent } from './components/change-password/change-password.component';
import { SentRecoverEmailComponent } from './components/sent-recover-email/sent-recover-email.component';
import { ResetPasswordRoutingModule } from './reset-password-routing.module';
import { ResetPasswordComponent } from './reset-password.component';
import { ResetPasswordResolver } from './reset-password.resolver';
import { ResetPasswordService } from './reset-password.service';
import { ResetTempPasswordComponent } from '@app/reset-password/components/reset-temp-password/reset-temp-password.component';
import { OktaService } from '@app/reset-password/components/sent-recover-email/okta.service';

@NgModule({
  imports: [CommonModule, SharedModule, ResetPasswordRoutingModule],
  declarations: [
    ResetPasswordComponent,
    SentRecoverEmailComponent,
    ChangePasswordComponent,
    ResetTempPasswordComponent,
  ],
  providers: [ResetPasswordService, ResetPasswordResolver, OktaService],
})
export class ResetPasswordModule {}
